import { Component, Input, OnInit } from "@angular/core";
import { ITimelineEntryWithData } from "@directives/_veri/v-timeline/v-timeline.component";
import { IVehicle } from "@interfaces/IVehicle";
import { IZoneWithProbes } from "@temperature/_models/temperature/ITemperatureZone";
import './zone-detail-page.component.scss';

@Component({
    selector: 'zone-detail-page',
    template: require('./zone-detail-page.component.html')
})
export class ZoneDetailPageComponent implements OnInit {
    @Input() vehicle: IVehicle;
    @Input() zone: IZoneWithProbes;

    @Input() startDate: Date;
    @Input() endDate: Date;

    @Input() timelineEntries: ITimelineEntryWithData<number>[] = [];

    // ---

    zoneTimelineEntries: ITimelineEntryWithData<number>[] = [];

    // ---

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges() {
        if (this.zone && this.timelineEntries) {
            this.zoneTimelineEntries = this.timelineEntries.filter(t => t.data == this.zone.Id || t.data === undefined)
        }
    }

    // ---
}
